import axios from "axios";

//export const BASE_URL = "https://localhost:7029";
export const BASE_URL = "https://www.plataformaeduserver.net/api";


const axiosEduServer = axios.create({
  baseURL: BASE_URL,
});

axiosEduServer.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem("userInfoES"))?.token}`
  return config
})

// Interceptor de respuesta para manejar errores 401 (token expirado)
axiosEduServer.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expirado o no autorizado
      const userInfo = JSON.parse(localStorage.getItem("userInfoES") || "{}");
      if (userInfo?.token) {
        // Limpiar sesión
        localStorage.removeItem("userInfoES");
        // Redirigir al login
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export { axiosEduServer };